var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.001 10.333H2.668a1 1 0 0 0-1 1V17h5.333m0-6.667V17m0-6.667V2a1 1 0 0 1 1-1h3.334a1 1 0 0 1 1 1v4.333M7 17h5.334m0 0H17V7.333a1 1 0 0 0-1-1h-3.666m0 10.667V6.333",
    stroke: "#979BA8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarGraph);
export default __webpack_public_path__ + "static/media/bar-graph.6dd7ac4ce68bafce19ca55301152153c.svg";
export { ForwardRef as ReactComponent };